module.exports = __webpack_public_path__ + "static/media/image-solid.205a8432.svg";